// src/App.js
import React, { useState, useEffect } from "react";
import ReactGA from "./utils/Analytic"; // Import ReactGA
import {
    BrowserRouter as Router,
    Route,
    Routes,
    useLocation,
} from "react-router-dom";
import RequireAuth from "./utils/RequireAuth";
import { Box } from "@chakra-ui/react";
import { AuthProvider } from "./context/AuthContext";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LandingPage from "./components/LandingPage";
import HomePage from "./components/HomePage";
import Dashboard from "./components/Dashboard";
import LoginPage from "./components/LoginPage";
import LoginPageStaff from "./components/LoginPageStaff";
import NewsDetailPage from "./components/NewsDetailPage";
import MapOfficeLocation from "./components/MapOfficeLocation";
import MapOfficePage from "./components/MapOfficePage";
//import FormVaccineManagement from "./components/FormVaccineManagement";
import UserProfile from "./components/UserProfile";
import EditFarmerProfile from "./components/EditFarmerProfile";


// ---- Vaccine Inventory Management -------------------//
import VaccineProductionReceiveList from "./components/VaccineProductionReceiveList";
import VaccineProductionReceiveForm from "./components/VaccineProductionReceiveForm";
//import VaccineReceiveList from "./components/VaccineReceiveList";
//import VaccineReceiveForm from "./components/VaccineReceiveForm";
import VaccineRequisitionList from "./components/VaccineRequisitionList";
import VaccineRequisitionForm from "./components/VaccineRequisitionForm";
import VaccineRequisitionRequestList from "./components/VaccineRequisitionRequestList";
import VaccineRequisitionRequestForm from "./components/VaccineRequisitionRequestForm";
import VaccineRequisitionReceiveList from "./components/VaccineRequisitionReceiveList";
import VaccineRequisitionReceiveForm from "./components/VaccineRequisitionReceiveForm";
import VaccinePreventionRequisitionList from "./components/VaccinePreventionRequisitionList";
import VaccinePreventionRequisitionForm from "./components/VaccinePreventionRequisitionForm";
import VaccinePreventionRequisitionRequestList from "./components/VaccinePreventionRequisitionRequestList";
import VaccinePreventionRequisitionRequestForm from "./components/VaccinePreventionRequisitionRequestForm";
import VaccinePreventionRequisitionReceiveList from "./components/VaccinePreventionRequisitionReceiveList";
import VaccinePreventionRequisitionReceiveForm from "./components/VaccinePreventionRequisitionReceiveForm";
import VaccineReturnList from "./components/VaccineReturnList";
import VaccineReturnForm from "./components/VaccineReturnForm";
import VaccineReturnRequestList from "./components/VaccineReturnRequestList";
import VaccineReturnRequestForm from "./components/VaccineReturnRequestForm";
import VaccineAdjustmentList from "./components/VaccineAdjustmentList";
import VaccineAdjustmentForm from "./components/VaccineAdjustmentForm";
import VaccineTransferList from "./components/VaccineTransferList";
import VaccineTransferForm from "./components/VaccineTransferForm";
import VaccineProtectRequisitionList from "./components/VaccineProtectRequisitionList";
import VaccineProtectRequisitionForm from "./components/VaccineProtectRequisitionForm";

// ----- Vaccine Sale Management -------------------//
import VaccineSaleList from "./components/VaccineSaleList";
import VaccineSaleForm from "./components/VaccineSaleForm";
import VaccineReserveByFarmer from "./components/VaccineReserveByFarmer";
import VaccineReservationList from "./components/VaccineReservationList";
import VaccineReservationForm from "./components/VaccineReservationForm";
import StaffVaccineReservationList from "./components/StaffVaccineReservationList";
import StaffVaccineReservationDetail from "./components/StaffVaccineReservationDetail";
import OfficeRsvList from "./components/OfficeRsvList";
import OfficeRsvForm from "./components/OfficeRsvForm";

//----- Vaccine Protection Budget Management -------------------//
import VaccineEstimateList from "./components/VaccineEstimateList";
import VaccineEstimateForm from "./components/VaccineEstimateForm";


//----- Vaccine Distribution Budget Management -------------------//
import VaccineDistributionEstimateList from "./components/VaccineDistributionEstimateList";
import VaccineDistributionEstimateForm from "./components/VaccineDistributionEstimateForm";

//----- Vaccine Estimate Management -------------------//
import VaccineEstimateProductionList from "./components/VaccineEstimateProductionList";
import VaccineEstimateProductionForm from "./components/VaccineEstimateProductionForm";
import VaccineEstimateDistributionList from "./components/VaccineEstimateDistributionList";
import VaccineEstimateDistributionForm from "./components/VaccineEstimateDistributionForm";
import VaccineEstimatePreventionList from "./components/VaccineEstimatePreventionList";
import VaccineEstimatePreventionForm from "./components/VaccineEstimatePreventionForm";

//----- Master Data Management -------------------//
import WarehouseManagement from "./components/master/WarehouseManagement";
import VaccineManagement from "./components/master/VaccineManagement";
import VaccineLotManagement from "./components/master/VaccineLotManagement";
import LivestockTypeManagement from "./components/master/LivestockTypeManagement";
import DLDOfficeManagement from "./components/master/DLDOfficeManagement";
import RolesManagement from "./components/master/RolesManagement";
import DLDEmployeeManagement from "./components/master/DLDEmployeeManagement";
import FarmerUserManagement from "./components/master/FarmerUserManagement";

//----- Refistration Form -------------------//
import RegistrationFarmer from "./components/RegistrationFarmer";
import RegistrationOfficeStaff from "./components/RegistrationOfficeStaff";

//----- Report -------------------//
import VaccineSummary from "./components/reports/VaccineSummary";
import VaccineInventoryReport from "./components/reports/VaccineInventoryReport";
import VaccineInventoryByDateReport from "./components/reports/VaccineInventoryByDateReport";
import VaccineInventoryWithLotReport from "./components/reports/VaccineInventoryWithLotReport";
import VaccineAboutExpireReport from "./components/reports/VaccineAboutExpireReport";
import VaccineProductionReport from "./components/reports/VaccineProductionReport";
import VaccineQCResultReport from "./components/reports/VaccineQCResultReport";
import VaccineReservationReport from "./components/reports/VaccineReservationReport";
import VaccineReservationSummaryReport from "./components/reports/VaccineReservationSummaryReport";
import VaccineReservationConfirmation from "./components/reports/VaccineReservationConfirmation";
//import VaccineReservationConfirmation from "./components/reports/VaccineReservationMockup";
import VaccineSaleOrderReport from "./components/reports/VaccineSaleOrderReport";
import VaccineUsageSatisfactionReport from "./components/reports/VaccineUsageSatisfactionReport";
import AnimalEpidemicReport from "./components/reports/AnimalEpidemicReport";
import LivestockAmountReport from "./components/reports/LivestockAmountReport";
import VaccineInventoryRegionSummaryReport from "./components/reports/VaccineInventoryRegionSummaryReport";
import VaccineInventoryByWarehouseLevelReport from "./components/reports/VaccineInventoryByWarehouseLevelReport";
import VaccineRequisitionReport from "./components/reports/VaccineRequisitionReport";

import VaccineProductionPlanReport from "./components/reports/VaccineProductionPlanReport";
import VaccineEstimateDistributionReport from "./components/reports/VaccineEstimateDistributionReport";
import VaccineEstimatePreventionReport from "./components/reports/VaccineEstimatePreventionReport";


import VisitorCommentsReport from "./components/reports/VisitorCommentsReport";

import UsersLoginLogReport from "./components/reports/UsersLoginLogReport";
import SystemUsageDashboard from "./components/reports/SystemUsageDashboard";
import VaccineInventoryDashboard from "./components/reports/VaccineInventoryDashboard";
import VaccineShippingReport from "./components/reports/VaccineShippingReport";
import VaccineUsageEvaluateReport from "./components/reports/VaccineUsageEvaluateReport";
import VaccineRequisitionFundingSummary from "./components/reports/VaccineRequisitionFundingSummary";
import VaccineFundingMonthlySummary from "./components/reports/VaccineFundingMonthlySummary";


import AuditLogReport from "./components/reports/AuditLogReport";
//----- Website Content -------------------//
import VaccineInfo from "./components/VaccineInfo";
import DiseaseInfo from "./components/DiseaseInfo";
import WebContentEpidemic from "./components/WebContentEpidemic";
//import DistributionPoint from "./components/DistributionPoint";
import VaccineUsageOverview from "./components/VaccineUsageOverview";
import LivestockAmountOverview from "./components/LivestockAmountOverview";

//----- Questionnaire -------------------//
import QuestionnaireBuilder from "./components/QuestionnaireBuilder";
import QuestionnaireList from "./components/QuestionnaireList";
import QuestionnaireForm from "./components/QuestionnaireForm";
import ResponseList from "./components/ResponseList";
import VaccineQuestionnaireForm from "./components/VaccineQuestionnaireForm";
import VaccineUsageEvaluateQuestionnaire from "./components/VaccineUsageEvaluateQuestionnaire";

//----- Infographic -------------------//
import VaccineInfographic from "./components/VaccineInfographic"

import VideoPlayerPage from "./components/VideoPlayerPage";
import FarmerUserManualPage from "./components/FarmerUserManualPage";

import { ChakraProvider } from "@chakra-ui/react";
import theme from "./themev";
import VaccinePreventionDistributionReport from "./components/reports/VaccinePreventionDistributionReport";
import VaccinePreventionDemandPlanReport from "./components/reports/VaccinePreventionDemandPlanReport";
import AssetForm from "./components/AssetForm";
import AssetSearch from "./components/AssetSearch";
import './styles/datepicker.css';

const Layout = ({ children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleSidebar = () => setIsOpen(!isOpen);
    const closeSidebar = () => setIsOpen(false); // เพิ่มฟังก์ชันปิด Sidebar
    const location = useLocation();
    useEffect(() => {
        // Track ทุกครั้งที่เปลี่ยนหน้า
        ReactGA.send({ hitType: "pageview", page: location.pathname });
    }, [location]);


    const isLandingPage = location.pathname === "/";

    return (
        <Box display="flex" flexDirection="column" minH="100vh">
            {!isLandingPage && (
                <Header toggleSidebar={toggleSidebar} isOpen={isOpen} />
            )}
            <Box
                display="flex"
                flex="1"
                overflow="hidden"
                pt={isLandingPage ? "0" : "90px"} // ปรับตามความสูง Header
            >
                {!isLandingPage && <Sidebar isOpen={isOpen} onClose={closeSidebar} />}
                <Box
                    flex="1"
                    ml={{ base: "0", md: isOpen ? "250px" : "0px" }} // ปรับ ml ใน mobile
                    overflowY="auto"
                >
                    {children}
                </Box>
            </Box>
            {!isLandingPage && <Footer />}
        </Box>
    );
};

const App = () => {
    const [currentTheme, setCurrentTheme] = useState(theme);

    return (
        <ChakraProvider theme={currentTheme}>
            <AuthProvider>
                <Router>
                    <Layout>
                        <Routes>
                            <Route path="/" element={<LandingPage />} />
                            <Route path="/dashboard" element={<Dashboard />} />
                            <Route path="/login" element={<LoginPage />} />
                            <Route path="/loginstaff" element={<LoginPageStaff />} />
                            <Route path="/home" element={<HomePage />} />
                            <Route path="/newsdetail" element={<NewsDetailPage />} />
                            <Route path="/mapofficelocation" element={<MapOfficeLocation />} />
                            <Route path="/mapoffice" element={<MapOfficePage />} />
                            <Route path="/distributionpoint" element={<MapOfficePage />} />
                            <Route path="/registrationfarmer" element={<RegistrationFarmer />} />
                            <Route path="/profile" element={<UserProfile />} />
                            <Route path="/farmerprofile" element={<EditFarmerProfile />} />

//----- Website Content -------------------//
                            <Route path="/registrationofficestaff" element={<RegistrationOfficeStaff />} />
                            <Route path="/vaccineinfo" element={<VaccineInfo />} />
                            <Route path="/diseaseinfo" element={<DiseaseInfo />} />
                            <Route path="/webcontentepidemic" element={<WebContentEpidemic />} />
                            <Route path="/vaccineusageoverview" element={<VaccineUsageOverview />} />
                            <Route path="/livestockamountoverview" element={<LivestockAmountOverview />} />


                            {/* --------- Protected routes --------- */}
                            <Route element={<RequireAuth />}>

// ----- Vaccine Reservation Management -------------------//
                                <Route path="/vaccinereservation" element={<VaccineReserveByFarmer />} />
                                <Route path="/vaccinereservationlist" element={<VaccineReservationList />} />
                                <Route path="/vaccinereservation/:reservationId" element={<VaccineReservationForm />} />
                                <Route path="/vaccinereservation/new" element={<VaccineReservationForm />} />
                                <Route path="/vaccinesalelist" element={<VaccineSaleList />} />
                                <Route path="/vaccinesale/:transactionId" element={<VaccineSaleForm />} />
                                <Route path="/vaccinesale/new" element={<VaccineSaleForm />} />
                                <Route path="/staffvaccinereservationlist" element={<StaffVaccineReservationList />} />
                                <Route path="/staffvaccinereservationdetail/:reservationId" element={<StaffVaccineReservationDetail />} />
                                <Route path="/staffvaccinereservationdetail/new" element={<StaffVaccineReservationDetail />} />
                                <Route path="/officersvlist" element={<OfficeRsvList />} />
                                <Route path="/officersv/new" element={<OfficeRsvForm />} />
                                <Route path="/officersv/:reservationId" element={<OfficeRsvForm />} />

// ----- Vaccine Protection Budget Management -------------------//
                                <Route path="/vaccineestimatelist" element={<VaccineEstimateList />} />
                                <Route path="/vaccineestimate/:estimateId" element={<VaccineEstimateForm />} />
                                <Route path="/vaccineestimate/new" element={<VaccineEstimateForm />} />


// ----- Vaccine Distribution Budget Management -------------------//
                                <Route path="/vaccinedistributionestimatelist" element={<VaccineDistributionEstimateList />} />
                                <Route path="/vaccinedistributionestimate/:estimateId" element={<VaccineDistributionEstimateForm />} />
                                <Route path="/vaccinedistributionestimate/new" element={<VaccineDistributionEstimateForm />} />

// ----- Vaccine Inventory Management -------------------//

                                <Route path="/vaccineproductionreceivelist" element={<VaccineProductionReceiveList />} />
                                <Route path="/vaccineproductionreceive/:transactionId" element={<VaccineProductionReceiveForm />} />
                                <Route path="/vaccineproductionreceive/new" element={<VaccineProductionReceiveForm />} />
                                {/*
              <Route path="/vaccinereceivelist" element={<VaccineReceiveList />} />
              <Route path="/vaccinereceive/:transactionId" element={<VaccineReceiveForm />} />
              <Route path="/vaccinereceive/new" element={<VaccineReceiveForm />} />
              */}
                                <Route path="/vaccinereceivelist" element={<VaccineRequisitionReceiveList />} />
                                <Route path="/vaccinereceive/:transactionId" element={<VaccineRequisitionReceiveForm />} />
                                <Route path="/vaccinereceive/new" element={<VaccineRequisitionReceiveForm />} />
                                <Route path="/vaccinerequisitionlist" element={<VaccineRequisitionList />} />
                                <Route path="/vaccinerequisition/:transactionId" element={<VaccineRequisitionForm />} />
                                <Route path="/vaccinerequisition/new" element={<VaccineRequisitionForm />} />
                                <Route path="/vaccinerequisitionrequestlist" element={<VaccineRequisitionRequestList />} />
                                <Route path="/vaccinerequisitionrequest/:transactionId" element={<VaccineRequisitionRequestForm />} />
                                <Route path="/vaccinerequisitionrequest/new" element={<VaccineRequisitionRequestForm />} />

                                
                                <Route path="/vaccinepreventionrequisitionlist" element={<VaccinePreventionRequisitionList />} />
                                <Route path="/vaccinepreventionrequisition/:transactionId" element={<VaccinePreventionRequisitionForm />} />
                                <Route path="/vaccinepreventionrequisition/new" element={<VaccinePreventionRequisitionForm />} />
                                <Route path="/vaccinepreventionrequisitionrequestlist" element={<VaccinePreventionRequisitionRequestList />} />
                                <Route path="/vaccinepreventionrequisitionrequest/:transactionId" element={<VaccinePreventionRequisitionRequestForm />} />
                                <Route path="/vaccinepreventionreceivelist" element={<VaccinePreventionRequisitionReceiveList />} />
                                <Route path="/vaccinepreventionreceive/:transactionId" element={<VaccinePreventionRequisitionReceiveForm />} />

                                <Route path="/vaccinereturnlist" element={<VaccineReturnList />} />
                                <Route path="/vaccinereturn/:transactionId" element={<VaccineReturnForm />} />
                                <Route path="/vaccinereturn/new" element={<VaccineReturnForm />} />
                                <Route path="/vaccinereturnrequestlist" element={<VaccineReturnRequestList />} />
                                <Route path="/vaccinereturnrequest/:transactionId" element={<VaccineReturnRequestForm />} />
                                <Route path="/vaccinereturnrequest/new" element={<VaccineReturnRequestForm />} />

                                <Route path="/vaccineadjustmentlist" element={<VaccineAdjustmentList />} />
                                <Route path="/vaccineadjustment/:transactionId" element={<VaccineAdjustmentForm />} />
                                <Route path="/vaccineadjustment/new" element={<VaccineAdjustmentForm />} />
                                <Route path="/vaccinetransferlist" element={<VaccineTransferList />} />
                                <Route path="/vaccinetransfer/:transactionId" element={<VaccineTransferForm />} />
                                <Route path="/vaccinetransfer/new" element={<VaccineTransferForm />} />
                                <Route path="/vaccineprotectrequisitionlist" element={<VaccineProtectRequisitionList />} />
                                <Route path="/vaccineprotectrequisition/:transactionId" element={<VaccineProtectRequisitionForm />} />
                                <Route path="/vaccineprotectrequisition/new" element={<VaccineProtectRequisitionForm />} />

// ----- Vaccine Estimate ---------------------//
                                <Route path="/vaccineestimateproductionlist" element={<VaccineEstimateProductionList />} />
                                <Route path="/vaccineestimateproduction/new" element={<VaccineEstimateProductionForm />} />
                                <Route path="/vaccineestimateproduction/:transactionId" element={<VaccineEstimateProductionForm />} />
                                <Route path="/vaccineestimatedistributionlist" element={<VaccineEstimateDistributionList />} />
                                <Route path="/vaccineestimatedistribution/new" element={<VaccineEstimateDistributionForm />} />
                                <Route path="/vaccineestimatedistribution/:transactionId" element={<VaccineEstimateDistributionForm />} />
                                <Route path="/vaccineestimatepreventionlist" element={<VaccineEstimatePreventionList />} />
                                <Route path="/vaccineestimateprevention/new" element={<VaccineEstimatePreventionForm />} />
                                <Route path="/vaccineestimateprevention/:transactionId" element={<VaccineEstimatePreventionForm />} />


// ----- Report Management -------------------//
                                <Route path="/vaccinesummary" element={<VaccineSummary />} />
                                <Route path="/vaccineinventoryreport" element={<VaccineInventoryReport />} />
                                <Route path="/vaccineinventorybydatereport" element={<VaccineInventoryByDateReport />} />
                                <Route path="/vaccineinventorywithlotreport" element={<VaccineInventoryWithLotReport />} />
                                <Route path="/vaccineaboutexpirereport" element={<VaccineAboutExpireReport />} />
                                <Route path="/vaccineproductionreport" element={<VaccineProductionReport />} />
                                <Route path="/vaccineqcresultreport" element={<VaccineQCResultReport />} />
                                <Route path="/vaccinereservationreport" element={<VaccineReservationReport />} />
                                <Route path="/vaccinereservationsummaryreport" element={<VaccineReservationSummaryReport />} />
                                <Route path="/vaccinereservationconfirm" element={<VaccineReservationConfirmation />} />
                                <Route path="/vaccinesaleorderreport" element={<VaccineSaleOrderReport />} />
                                <Route path="/vaccinepreventiondemandplanreport" element={<VaccinePreventionDemandPlanReport />} />
                                <Route path="/vaccinepreventiondistributionreport" element={<VaccinePreventionDistributionReport />} />
                                <Route path="/vaccineusagesatisfactionreport" element={<VaccineUsageSatisfactionReport />} />
                                <Route path="/animalepidemicreport" element={<AnimalEpidemicReport />} />
                                <Route path="/livestockamountreport" element={<LivestockAmountReport />} />

                                <Route path="/visitorcommentsreport" element={<VisitorCommentsReport />} />

                                <Route path="/userloginlogreport" element={<UsersLoginLogReport />} />
                                <Route path="/systemusagedashboard" element={<SystemUsageDashboard />} />
                                <Route path="/vaccineinventorydashboard" element={<VaccineInventoryDashboard />} />
                                <Route path="/auditlogreport" element={<AuditLogReport />} />
                                <Route path="/vaccineshippingreport" element={<VaccineShippingReport />} />
                                <Route path="/vaccineusageevaluatereport" element={<VaccineUsageEvaluateReport />} />
                                <Route path="/vaccineInventoryregionreport" element={<VaccineInventoryRegionSummaryReport />} />
                                <Route path="/vaccineinventorybywarehouselevelreport" element={<VaccineInventoryByWarehouseLevelReport />} />
                                <Route path="/vaccinerequisitionfundingsummary" element={<VaccineRequisitionFundingSummary />} />
                                <Route path="/vaccinefundingmonthlysummary" element={<VaccineFundingMonthlySummary />} />
                                <Route path="/vaccinerequisitionreport" element={<VaccineRequisitionReport />} />


                                <Route path="/vaccineproductionplanreport" element={<VaccineProductionPlanReport />} />
                                <Route path="/vaccinepestimatedistributionreport" element={<VaccineEstimateDistributionReport />} />
                                <Route path="/vaccinepestimatepreventionreport" element={<VaccineEstimatePreventionReport />} />

// ----- Master Data Management -------------------//
                                <Route path="/masterwarehouse" element={<WarehouseManagement />} />
                                <Route path="/mastervaccine" element={<VaccineManagement />} />
                                <Route path="/mastervaccinelot" element={<VaccineLotManagement />} />
                                <Route path="/masterlivestocktype" element={<LivestockTypeManagement />} />
                                <Route path="/masterdldoffice" element={<DLDOfficeManagement />} />
                                <Route path="/masterroles" element={<RolesManagement />} />
                                <Route path="/masterdldemployee" element={<DLDEmployeeManagement />} />
                                <Route path="/masterfarmer" element={<FarmerUserManagement />} />
                                <Route path="/assetsearch" element={<AssetSearch />} />
                                <Route path="/asset/new" element={<AssetForm />} />
                                <Route path="/asset/:AssetID" element={<AssetForm />} />

// ----- Questionnaire -------------------//
                                <Route path="/questionnaire-builder" element={<QuestionnaireBuilder />} />
                                <Route path="/questionnaire-list" element={<QuestionnaireList />} />
                                <Route path="/questionnaire-form/:id" element={<QuestionnaireForm />} />
                                <Route path="/response-list/:id" element={<ResponseList />} />
                                <Route path="/questionnaire" element={<VaccineQuestionnaireForm />} />
                                <Route path="/usageevalquestionnaire" element={<VaccineUsageEvaluateQuestionnaire />} />

//----- Infographic -------------------//
                                <Route path="/vaccineinfographic" element={<VaccineInfographic />} />

//----- Video Player -------------------//
                                <Route path="/trainingvideo" element={<VideoPlayerPage />} />
                                <Route path="/usermanual" element={<FarmerUserManualPage />} />
                            </Route>
                        </Routes>

                    </Layout>
                </Router>
            </AuthProvider>
        </ChakraProvider>
    );
};

export default App;
